export default {"src":"/_next/static/media/mochi-coin-circle-fill.5cddd285.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};